import { message } from 'antd';
import { isArray, isString } from 'lodash';

export const showError = (msg, { displayTime = 30, messagePrefix = '' } = {}) => {
  let msgToDisplay = `${messagePrefix}Unknown error`;

  if (isString(msg) || isArray(msg)) {
    msgToDisplay = (
      <div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'left' }}>
        {(isString(msg) ? msg.split('\n') : msg).map((x) => (
          <div key={x.length}>
            {messagePrefix}
            {x}
          </div>
        ))}
      </div>
    );
  }

  return message.error(msgToDisplay, displayTime);
};

export const onError = (e) => {
  if (e?.bypassOutput) {
    return;
  }

  showError(e?.message);
};

export const onTimeTrackerError = (e) => {
  if (e?.bypassOutput) {
    return;
  }

  showError(e?.message, { messagePrefix: 'Time tracker error: ' });
};
